//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Determines which price to use when creating orders in MoySklad */
export enum OrderPriceType {
  /** Use marketplace price with discounts applied */
  PriceWithDisc = 0,
  /** Use seller's original price without marketplace discounts */
  FinishedPrice = 1
}
